// extracted by mini-css-extract-plugin
var _1 = "GarminSettings-module__button___yKOFk";
var _2 = "GarminSettings-module__disabled___TX4r8";
var _3 = "GarminSettings-module__loading___Cb0lK";
export { _1 as "button", _2 as "disabled", _3 as "loading" }
